import BasketApi from "../Api/basket-api";
import {modal} from "../UI/modal";


const updateItem = (item, count, coupon, paymentVariant, events) => {
    let id = item.dataset.basket_id;
    item.classList.add('preloader');


    BasketApi.update(id, count[0].count || 0, coupon, paymentVariant)
        .then(e => e.json())
        .then(e => {
            events.dispatch('item.updated', e);
        })
        .catch(e => {
            events.dispatch('item.updated.error', e);
            modal({'message': 'Ошибка обновления <h3>Попробуйте ещё раз.</h3>'} );
        })
        .finally(() => {
            item.classList.remove('preloader');
        });
};
export default updateItem;
